import getTrackLineRequests, {GetTrackLineRequestsOptions} from './getTrackLineRequests';
import {GetSyncPromise, SyncPromise} from '../react/useGetSyncPromise';
import {find, every} from 'lodash';

export interface GetSyncTrackLinesOptions extends GetTrackLineRequestsOptions {
    getSyncPromise: GetSyncPromise;
}

export default function getSyncTrackLines({
    getSyncPromise,
    ...options
}: GetSyncTrackLinesOptions): SyncPromise<TrackLine[]> {

    const syncPromises = getTrackLineRequests(options).map((request): SyncPromise<TrackLine> => {

        const [geometry, error, isGeometryLoaded] = request.type === 'sync' ?
            [request.geometry, undefined, true] :
            getSyncPromise(request.geometry, request.loadingGeometry);

        return [{
            type: 'Feature',
            properties: {
                ...request.properties,
                isGeometryLoaded
            },
            geometry,
        }, error, isGeometryLoaded];
    });

    return [
        syncPromises.map(([line]) => line),
        find(syncPromises.map(([, error]) => error)),
        every(syncPromises.map(([, , isLoaded]) => isLoaded)),
    ];
}
